import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { MatPaginatorModule } from '@angular/material/paginator';
import {MatSlideToggleModule} from '@angular/material/slide-toggle'; 
import { MatSortModule } from '@angular/material/sort';

// this module only contains exports to other modules
@NgModule({
	declarations: [],
	imports: [],
	exports: [
		FormsModule,
		ReactiveFormsModule,
		HttpClientModule,
		MatDialogModule, MatButtonModule, MatToolbarModule,
		MatCardModule, MatMenuModule, MatIconModule,
		MatTooltipModule, MatDividerModule, MatFormFieldModule,
		MatDatepickerModule, MatSnackBarModule, MatSortModule,
		MatProgressBarModule, MatListModule, MatSidenavModule,
		MatSelectModule, MatInputModule, MatBadgeModule,
		MatExpansionModule, MatTableModule, MatTabsModule,
		MatProgressSpinnerModule, MatRadioModule, MatCheckboxModule,
		MatAutocompleteModule, MatPaginatorModule,
		NgxMatDatetimePickerModule, NgxMatTimepickerModule,
		NgxMatMomentModule, MatMomentDateModule, MatSlideToggleModule
	]
})
export class LibrariesModule { }
